export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CHANGE_MANAGEMENT_LIST_DATA_SUCCESS = "CHANGE_MANAGEMENT_LIST_DATA_SUCCESS";
export const CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS = "CHANGE_MANAGEMENT_SINGLE_DATA_SUCCESS";
export const CHANGE_MANAGEMENT_DROP_DATA_SUCCESS = "CHANGE_MANAGEMENT_DROP_DATA_SUCCESS";
export const CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS = 'CHANGE_MANAGEMENT_TABLE_DATA_SUCCESS';
export const CHANGE_MANAGEMENT_COUNT_SUCCESS = 'CHANGE_MANAGEMENT_COUNT_SUCCESS';
export const CHANGE_MANAGEMENT_RECORD_SUCCESS = 'CHANGE_MANAGEMENT_RECORD_SUCCESS';
export const CHANGE_MANAGEMENT_RECORD_CLEAR = 'CHANGE_MANAGEMENT_RECORD_CLEAR';